export const TextField = {
    MuiTextField: {
        defaultProps: {
            variant: "outlined",
            margin: "dense"
        },
        styleOverrides: {
            root: {}
        }
    }
};

//# sourceMappingURL=TextField.js.map